import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: "https://court.gov.tm/api/",
})
export default axiosInstance;

export const AI_URL = "https://court.gov.tm"